import React from 'react';
import Header from '../../components/header/header';
import './mission.scss';
import { motion } from "motion/react";

const VisionMission = () => {
  return (
    <div className="vision-mission">
      <Header />

      {/* Hero Section */}
      <section className="hero9">
        <div className="hero-content9">
          <h1>Our Vision & Mission</h1>
          <p>Guided by purpose, united in faith, transforming our community and the world</p>
        </div>
      </section>

      {/* Vision & Mission Cards - Slide in from opposite sides */}
      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
        className="section9"
      >
        <div className="vm-grid">
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="vm-card"
          >
            <div className="vm-icon">🌍</div>
            <h3>Our Vision</h3>
            <p>
              To be a church where people experience the transforming power of God's love, growing in faith and making a lasting impact in our community and beyond.
            </p>
            <p>
              We envision a vibrant community of believers who are deeply rooted in Christ, passionately pursuing His presence, and actively demonstrating His love to the world. We see families restored, lives transformed, and communities renewed through the power of the Gospel.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="vm-card"
          >
            <div className="vm-icon">🎯</div>
            <h3>Our Mission</h3>
            <p>
              We exist to glorify God by making disciples of Jesus Christ through authentic worship, biblical teaching, genuine fellowship, and compassionate service.
            </p>
            <p>
              Our mission is to create an environment where everyone can encounter God, experience authentic community, and be equipped to fulfill their God-given purpose. We are committed to spreading the Gospel and serving our community with excellence and love.
            </p>
          </motion.div>
        </div>
      </motion.section>

      {/* Core Values - Stagger up */}
      <motion.section
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.7 }}
        className="section9 miss-add"
      >
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div className="section-header9">
            <h2 className="section-title9 col-miss">Our Core Values</h2>
            <p className="section-subtitle9">These values guide everything we do as a church community</p>
          </div>

          <div className="values-grid">
            {[
              { emoji: "🙏", title: "Authentic Worship", desc: "We worship God in spirit and in truth, creating space for genuine encounters with His presence through heartfelt praise and adoration." },
              { emoji: "📖", title: "Biblical Teaching", desc: "We are committed to accurate, relevant teaching of God's Word that transforms lives and builds strong faith foundations." },
              { emoji: "❤️", title: "Genuine Community", desc: "We value authentic relationships where people can belong, grow, and support one another in their faith journey." },
              { emoji: "🌍", title: "Compassionate Service", desc: "We serve our community and world with generosity, meeting practical needs and sharing Christ's love through action." },
              { emoji: "🎯", title: "Intentional Discipleship", desc: "We are dedicated to helping every person grow in their relationship with Jesus and discover their God-given purpose." },
              { emoji: "🤝", title: "Radical Hospitality", desc: "We welcome everyone with open arms, creating an inclusive environment where all people feel valued and loved." }
            ].map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="value-item"
              >
                <span className="value-emoji">{value.emoji}</span>
                <h4>{value.title}</h4>
                <p>{value.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default VisionMission;
